import { atom } from "jotai";

export interface ScmpYouTubeVideo {
  playingId?: string;
}

export const scmpYouTubeVideoAtom = atom<ScmpYouTubeVideo>({
  playingId: undefined,
});
